import { FC } from "react";
import ThankYouContent from "./ThankYouContent";
import ThankYouScreenWrapper, { ThankYouScreenProps } from "./ThankYouScreenWrapper";

const ThankYouScreenContainerSpectre: FC<ThankYouScreenProps> = (props) => (
  <ThankYouScreenWrapper {...props} title="Thank you for applying for a Spectre account">
    <ThankYouContent embedded={props.embedded} />
  </ThankYouScreenWrapper>
);

export default ThankYouScreenContainerSpectre;
